import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MonthsComponent } from 'src/app/components/data/months/months.component';
import { YearsComponent } from 'src/app/components/data/years/years.component';
import { DataService } from 'src/app/shared/data/data.service';
import { ReportCalculations } from 'src/app/models/reportCalculations';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
 import 'jspdf-autotable';

@Component({
  selector: 'app-calculations',
  templateUrl: './calculations.component.html',
  styleUrls: ['./calculations.component.css']
})
export class CalculationsComponent implements OnInit {

  @ViewChild(MonthsComponent)
  private monthsComponent: MonthsComponent;

  @ViewChild(YearsComponent)
  private yearsComponent: YearsComponent;

  reportCalculations: ReportCalculations[];
  month: number;
  year: number;
  constructor(private dataService: DataService) { }

  ngOnInit() {
  }

  generujNaliczenia(type) {
    this.month = this.monthsComponent.selectedValue;
    this.year = this.yearsComponent.selectedValue;

    /*this.dataService.getReportsCalculations(this.monthsComponent.selectedValue, this.yearsComponent.selectedValue)
      .subscribe(reportCalculations => {
         this.reportCalculations = reportCalculations;
      });*/
    this.dataService.getReportsCalculationsPdf(this.monthsComponent.selectedValue, this.yearsComponent.selectedValue, type)
      .subscribe(doc => {


         const file = new window.Blob([doc], { type: 'application/pdf' });
         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
          return;
         }
         const data = window.URL.createObjectURL(file);

         var link = document.createElement('a');
         link.href = data;
         link.download = 'naliczenie.pdf';
         // this is necessary as link.click() does not work on the latest firefox
         link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

         setTimeout(function () {
             // For Firefox it is necessary to delay revoking the ObjectURL
             window.URL.revokeObjectURL(data);
         }, 100);


        // const fileURL = window.URL.createObjectURL(file);
         // window.open(fileURL, '_blank', '');

         // console.log(fileURL);
           // const file = new window.Blob([JSON.stringify(doc)], { type: 'application/pdf' });
           // const fileURL = window.URL.createObjectURL(file);

           //  window.open(fileURL, '_blank', '');
      });

  }
  /*print() {

    const fonts = {
      Roboto: {
        normal: 'fonts/Roboto-Regular.ttf',
        bold: 'fonts/Roboto-Medium.ttf'
      }
    };

    const title = 'ROZLICZENIE za miesiąc ' + this.month + '-' + this.year;
    const doc = new jspdf('p', 'pt');

   const header = function(data) {
      doc.setFontSize(18);
      doc.setTextColor(40);

      doc.setFont('Tahoma');
     // doc.setFontStyle(fonts.Roboto.normal);
      // doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
      doc.text(title, data.settings.margin.left, 50);
    };

    const _columns = [
      {title: 'Autor', key: 'authorName'},
      {title: 'Uwagi', key: 'note'},
      {title: 'Stan konta', key: 'stan'},
      {title: 'Naliczenie', key: 'provisionValue'}
  ];
  const _data = [ ];

  this.reportCalculations.forEach(x => {
    const item1 =  {'authorName' : x.authorName, 'note': x.note, 'stan': x.accountBalance, 'provisionValue': x.provisionValue };
    _data.push(item1);
  });

    doc.autoTable(_columns, _data, {
      addPageContent: header,
      margin: { top: 80},
       fontStyle: 'Tahoma',
       styles: {font: 'Tahoma'},
      // startY: 0.47 * doc.internal.pageSize.height,
      // styles: {overflow: 'linebreak'},
      theme: 'grid' });
    // doc.save('rozliczenie' + this.month + this.year + '.pdf');
  }
*/

}
